export default __webpack_public_path__ + "static/media/searchIcon.ab6fa564.svg";